import { SimpleChipExpression, ExpertChipExpression } from "@nrwl/query-emitter";

export enum SmartSearchMode {
  EXPERT = "expert",
  SIMPLE = "simple"
}

export class SingleChip {
  value: string;
  display: string;
  readonly = false;
  constructor(value: string, display: string, readonly?: boolean) {
    this.value = value;
    this.display = display;
    this.readonly = readonly;
  }
}

export class StateChipExpression extends SimpleChipExpression {
  readonlyState = false;

  constructor(keyword?:string, operator?:string, operands?:string[], readonlyState?: boolean) {
    super(keyword, operator, operands);
    this.readonlyState = readonlyState;
  }
}


export class AutocompleteOffer {
  value: string;
  display: string;
  internalInfo: any;
  dbInfo: any;

  constructor(value: string, display: string, internalInfo: any, dbInfo?: any) {
    this.value = value;
    this.display = display;
    this.internalInfo = internalInfo;
    this.dbInfo = dbInfo;
  }
}

export class SmartQueryInput {
  rawQuery: string;
  triggerSearch: boolean;
  parsedQuery: ExpertChipExpression[];
  inputText?: string;
  valid = false;
  constructor(rawQuery: string, valid = false, parsedQuery?: ExpertChipExpression[], triggerSearch?: boolean) {
    this.rawQuery = rawQuery;
    this.triggerSearch = triggerSearch;
    this.valid = valid;
    this.parsedQuery = parsedQuery;
  }

  countExpressions(): number {
    if (!this.valid) {
      return 0;
    }
    if (!this.parsedQuery) {
      return 0;
    }
    return this.parsedQuery.length;
  }
}
